import React from 'react';
import { Check, ChevronDown, ChevronRight } from 'lucide-react';

interface StepHeaderProps {
  stepNumber: number;
  title: React.ReactNode;
  status: 'pending' | 'current' | 'complete';
  isOpen: boolean;
}

export const StepHeader: React.FC<StepHeaderProps> = ({
  stepNumber,
  title,
  status,
  isOpen
}) => {
  const getStatusIcon = () => {
    if (status === 'complete') {
      return <Check className="w-5 h-5 text-green-400" />;
    }
    return (
      <span className={`w-5 h-5 rounded-full flex items-center justify-center text-sm font-medium ${
        status === 'current' ? 'bg-blue-500 text-white' : 'bg-slate-600 text-slate-300'
      }`}>
        {stepNumber}
      </span>
    );
  };

  return (
    <div className="flex items-center justify-between p-4 hover:bg-slate-700/50 transition-colors">
      <div className="flex items-center gap-3">
        {getStatusIcon()}
        <span className="font-medium text-slate-200">{title}</span>
      </div>
      {isOpen ? (
        <ChevronDown className="w-5 h-5 text-slate-400" />
      ) : (
        <ChevronRight className="w-5 h-5 text-slate-400" />
      )}
    </div>
  );
}; 